import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from '@blueprint/ui';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';

import { PropertyTypeRadioButtonWrapper } from '../../../search/common/Dropdown.styles';
import { updateFilter, propertyTypeSelector } from '../../../reducers/filters';
import { FilterOptions } from '../../../reducers/filters.types';

type RadioOptions = {
    options: FilterOptions;
    onPropertyTypeChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    propertyType: string | string[];
    excludeFarms: boolean;
};

const options: { [key: string]: string } = {
    '': 'Show all',
    all: 'All property types',
    houses: 'Houses',
    farms_land: 'Farms/land',
    flats: 'Flats'
};

const PropertyTypeRadioButtons: FC<RadioOptions> = ({
    options,
    onPropertyTypeChange,
    propertyType,
    excludeFarms
}) => {
    return (
        <>
            {options?.map((option) => {
                const { label, value } = option;

                const idKey = `desktop_subheader_property_type_option${
                    value ? `_${value}` : '_all'
                }`;

                const hasSelectedThisPropertyType = propertyType === value;

                return excludeFarms && value === 'farms_land' ? null : (
                    <Radio
                        key={`${value}-${label}`}
                        id={idKey}
                        data-testid={value}
                        name="option"
                        label={label}
                        value={value}
                        checked={hasSelectedThisPropertyType}
                        onChange={onPropertyTypeChange}
                    />
                );
            })}
        </>
    );
};

export const SelectPropertyType: FC<{ excludeFarms: boolean }> = ({
    excludeFarms = false
}) => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: propertyTypeSelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const onPropertyTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('propertyType', evt.currentTarget.value));
    };

    return (
        <MultiColumnDropdownWithLabel
            title={options[propertyTypeSelectedValue]}
            label="Property type"
            testId="PropertyType_testId"
            isLeft
            minWidthOverride="100%"
        >
            <PropertyTypeRadioButtonWrapper>
                <PropertyTypeRadioButtons
                    onPropertyTypeChange={onPropertyTypeChange}
                    propertyType={propertyTypeSelectedValue}
                    options={propertyTypeOptions}
                    excludeFarms={excludeFarms}
                />
            </PropertyTypeRadioButtonWrapper>
        </MultiColumnDropdownWithLabel>
    );
};
